import { Outlet, Route, Routes } from "react-router-dom";

import AdminLayout from "./components/admin/AdminLayout";
import AdminRouteGuard from "./components/admin/AdminRouteGuard";
import BugReportFab from "./components/BugReportFab";
import Header from "./components/Header";
import AdminAttachments from "./pages/admin/AdminAttachments";
import AdminBugList from "./pages/admin/AdminBugList";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminGlassPanels from "./pages/admin/AdminGlassPanels";
import AdminQuotationDetails from "./pages/admin/AdminQuotationDetails";
import AdminQuotationList from "./pages/admin/AdminQuotationList";
import AdminStores from "./pages/admin/AdminStores";
import ChangelogPage from "./pages/ChangelogPage";
import OnboardingPage from "./pages/OnboardingPage";
import QuotationDetails from "./pages/QuotationDetails";
import QuotationList from "./pages/QuotationList";
import Visualization3D from "./pages/Visualization3D";

const PublicLayout = () => (
  <>
    <Header />
    <Outlet />
  </>
);

function App() {
  return (
    <>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<OnboardingPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/quotations" element={<QuotationList />} />
          <Route path="/quotations/:slug" element={<QuotationDetails />} />
          <Route path="/3d-visualization" element={<Visualization3D />} />
          <Route path="/changelog" element={<ChangelogPage />} />
        </Route>

        <Route path="/admin" element={<AdminRouteGuard />}>
          <Route element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="quotations" element={<AdminQuotationList />} />
            <Route path="quotations/:slug" element={<AdminQuotationDetails />} />
            <Route path="products/panels" element={<AdminGlassPanels />} />
            <Route path="products/attachments" element={<AdminAttachments />} />
            <Route path="stores" element={<AdminStores />} />
            <Route path="bugs" element={<AdminBugList />} />
          </Route>
        </Route>
      </Routes>
      <BugReportFab />
    </>
  );
}

export default App;
